/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NewCommenterConfig_formValues = {
    readonly newCommenter: {
        readonly enabled: boolean | null;
    } | null;
    readonly " $refType": "NewCommenterConfig_formValues";
};
export type NewCommenterConfig_formValues$data = NewCommenterConfig_formValues;
export type NewCommenterConfig_formValues$key = {
    readonly " $data"?: NewCommenterConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"NewCommenterConfig_formValues">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewCommenterConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "NewCommenterConfiguration",
            "kind": "LinkedField",
            "name": "newCommenter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c5f8840abe8b86b4734777aa5eec6c48';
export default node;
